import { Fragment } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { ReactComponent as CaretUp } from "../../../assets/images/icons/CaretUp.svg";
import { ReactComponent as ArrowUp } from "../../../assets/images/icons/arrow-up.svg";
import line from "../../../assets/images/svg/line.svg";
import times from "../../../assets/images/svg/times.svg";
import { Dropdown1Interface, OptionsInterface } from "./dropDown.interface";

const Dropdown = ({
    options,
    defaultValue,
    value,
    onChange,
    title,
    classNames,
    arrowDownType = 1,
    arrowDownClassNames,
    optionsClassNames,
    arrowColor = "stroke-[#A0A3BD]",
    clearIcon = false,
    handleClear
}: Dropdown1Interface) => {
    return (
        <div className="w-full">
            <Listbox value={value} onChange={() => {}}>
                <div className="relative">
                    <Listbox.Label className="text-[14px]">{title}</Listbox.Label>
                    <Listbox.Button
                        className={`relative w-full rounded-lg bg-white border-[1.5px] border-gray-100 text-left sm:text-sm ${classNames}`}
                    >
                        {({ open }) => (
                            <div className="flex gap-4 items-center">
                                <div className="flex items-center gap-2">
                                    {value?.icon && <img src={value?.icon} alt="value" width={17} height={17} />}
                                    <span className="block truncate text-right">{value?.label}</span>
                                </div>
                                <span
                                    className={`pointer-events-none mr-auto inset-y-0 transition-transform duration-500 ${arrowDownClassNames} ${open ? "rotate-0" : "rotate-180"}`}
                                >
                                    {arrowDownType === 1 ? <CaretUp className={arrowColor} /> : <ArrowUp width={18} height={18} />}
                                </span>
                                {clearIcon && (
                                    <>
                                        <img src={line} alt="line" />
                                        <img
                                            src={times}
                                            alt="times"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                handleClear();
                                            }}
                                        />
                                    </>
                                )}
                            </div>
                        )}
                    </Listbox.Button>
                    <Transition as={Fragment} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
                        <Listbox.Options
                            className={`absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white drop-shadow-md text-base ring-1 ring-black ring-opacity-5 sm:text-sm z-50 no-scrollbar ${optionsClassNames}`}
                        >
                            {options.map((option: OptionsInterface, index: number) => (
                                <Listbox.Option
                                    key={index}
                                    className={({ active }) => `relative select-none py-2 pl-10 pr-4 cursor-pointer ${active ? "bg-[#F7F7FC]" : ""}`}
                                    defaultValue={defaultValue?.payload}
                                    value={option.payload}
                                    onClick={() => onChange(option)}
                                >
                                    {({ value }: any) => (
                                        <span className={`truncate flex items-center gap-3 my-2 ${value ? "font-medium" : "font-normal"}`}>
                                            {option.icon && <img src={option.icon} alt="option" width={24} height={24} />}
                                            <span>{option.label}</span>
                                        </span>
                                    )}
                                </Listbox.Option>
                            ))}
                        </Listbox.Options>
                    </Transition>
                </div>
            </Listbox>
        </div>
    );
};

export default Dropdown;
